module.exports = __webpack_public_path__ + "static/spanish-2e02d4c3d5267398dc118ca025b78af2.jpg";